import { view } from '@yola/ws-sdk';
import { LINE_HEIGHT_CLASS_NAME } from '../constants/responsive-class-names';
import constants from '../constants';

const { LINE_HEIGHT_UNIT } = constants.common;

const UNIT_SUFFIX = new RegExp(`${LINE_HEIGHT_UNIT}$`);

const getCustomLineHeight = (element, breakpoint) => {
  const classValue = view.accessors.getResponsiveClassValue({
    element,
    className: LINE_HEIGHT_CLASS_NAME,
    breakpoint,
  });

  if (classValue) {
    return classValue.value.replace(UNIT_SUFFIX, '');
  }

  return null;
};

export default getCustomLineHeight;
